import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import FormattedMessage from 'components/FormattedMessage'
import FormItem from 'components/Form/Item'
import Checkbox from 'components/Form/Checkbox'

const ProviderTermsAndConditionCheckbox = (props) => {
  const {
    provider: {
      id: providerId,
      termsAndConditions,
    },
    initialData,
  } = props

  const consentContentElement = useRef(null)

  useEffect(() => {
    const termsConditionsLink = consentContentElement?.current?.querySelector('a')

    // NOTE: eslint disabled because addEventListener returns undefined, so we don't need the result
    // eslint-disable-next-line no-unused-expressions
    termsConditionsLink?.addEventListener('click', openProviderTermsConditions)

    return () => {
      // eslint-disable-next-line no-unused-expressions
      termsConditionsLink?.removeEventListener('click', openProviderTermsConditions)
    }
  }, [])

  const openProviderTermsConditions = (event) => {
    event.preventDefault()

    window.open(
      '',
      'termsAndConditions',
      'width=700,height=500,menubar=no,location=no,resizable=yes,scrollbars=yes,status=no',
    ).document.write(termsAndConditions)
  }

  return (
    <FormItem
      name="providerTermsConditionsConsent"
      className={classNames(
        'contact-request-form__consent-wrapper',
        'contact-request-form__consent-wrapper--required',
      )}
    >
      <Checkbox
        name="providerTermsConditionsConsent"
        className="contact-request-form__consent"
        rules={{ required: true }}
        defaultValue={initialData.providerTermsConditionsConsentProviderId === providerId}
      >
        <span ref={consentContentElement}>
          <FormattedMessage id="contactRequestForm.providerTermsConditionsConsent" tagName="span" html />
        </span>
      </Checkbox>
    </FormItem>
  )
}

ProviderTermsAndConditionCheckbox.propTypes = {
  provider: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    termsAndConditions: PropTypes.string.isRequired,
  }).isRequired,
  initialData: PropTypes.shape({
    providerTermsConditionsConsentProviderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
}

export default ProviderTermsAndConditionCheckbox
